import { AxiosResponse } from "axios";
import talentApi from "./talent-api-config";
import { NpsAnswer, NpsInterface, NpsTrigger } from "../../models/nps.models";

class NpsApi {
    PATH = "/nps/";

    async fetchNpsData(): Promise<AxiosResponse<NpsInterface[]>> {
        return talentApi.get<NpsInterface[]>(`${this.PATH}?target=TALENT_TA`);
    }

    async submitNpsAnswer(answers: NpsAnswer[]): Promise<AxiosResponse<void>> {
        return talentApi.post<void>(`${this.PATH}`, { answers });
    }

    async checkTriggerNps(): Promise<AxiosResponse<NpsTrigger>> {
        return talentApi.get<NpsTrigger>(`${this.PATH}check/talent-ta/`);
    }
}

export const npsApi = new NpsApi();
